import { Suspense, lazy, useMemo } from "react";
import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
//#region src/use-carousel-reviews.tsx
var LazyCarouselReviews = lazy(() => import("./carousel-reviews-DZ6zvezS.js").then((n) => n.n).then((module) => ({ default: module.CarouselReviews })));
function CarouselReviews({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "carousel-reviews" }),
		children: /* @__PURE__ */ jsx(LazyCarouselReviews, { ...props })
	});
}
function CarouselReviewsContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "carousel-reviews" }),
		children: /* @__PURE__ */ jsx(LazyCarouselReviews, { ...props })
	});
}
var useCarouselReviewsContent = () => {
	return useMemo(() => ({ carouselReviews: { component: CarouselReviewsContent } }), []);
};
//#endregion
export { CarouselReviews, useCarouselReviewsContent };
